__turbopack_context__.v({
  "active": "audioPlayer-module-scss-module__jFDBGW__active",
  "audioContainer": "audioPlayer-module-scss-module__jFDBGW__audioContainer",
  "controls": "audioPlayer-module-scss-module__jFDBGW__controls",
  "lightTextColor": "audioPlayer-module-scss-module__jFDBGW__lightTextColor",
  "playButton": "audioPlayer-module-scss-module__jFDBGW__playButton",
  "progressBar": "audioPlayer-module-scss-module__jFDBGW__progressBar",
  "progressBarWrapper": "audioPlayer-module-scss-module__jFDBGW__progressBarWrapper",
  "slideAnimation": "audioPlayer-module-scss-module__jFDBGW__slideAnimation",
  "slideInRight": "audioPlayer-module-scss-module__jFDBGW__slideInRight",
  "timeEllapsed": "audioPlayer-module-scss-module__jFDBGW__timeEllapsed",
  "timeRemaining": "audioPlayer-module-scss-module__jFDBGW__timeRemaining",
  "timeRemainingIsActive": "audioPlayer-module-scss-module__jFDBGW__timeRemainingIsActive",
  "timeRemainingNotActive": "audioPlayer-module-scss-module__jFDBGW__timeRemainingNotActive",
});
